<template lang="pug">
  #intro.container-fluid
    .row
      .col-12.text-center
        img.mt-5(src="/assets/img/chapter1/title.png")
        h1.title.my-4.uppercase
          span.neutral-text Todo lo que necesitas
          br
          span.neutral-text.bolder saber sobre
          br
          span.accent-text.bolder el coronavirus
        h2
          | 17 de abril de 2020
    .row.d-flex.justify-content-center.align-items-center.mt-2
      img.arrow(src="/assets/img/chapter1/arrow.svg")
    Illustration.covid.d-flex.justify-content-center(src="/assets/img/chapter1/covid.svg")
</template>

<script>
import Illustration from "@/components/Illustration.vue";
import anime from "animejs/lib/anime.es.js";

export default {
  name: "Intro",
  components: {
    Illustration
  },
  data() {
    return {
      DOM: {}
    };
  },
  methods: {
    animate() {
      this.DOM.paths.forEach(path => {
        //console.log(path);
        setTimeout(() => {
          anime({
            targets: path,
            duration: anime.random(100, 1000),
            easing: "easeInOutSine",
            d: path.getAttribute("d"),
            loop: true,
            direction: "alternate",
            translateX: anime.random(0.1, 0.2),
            translateY: anime.random(0.1, 0.2)
          });
        }, anime.random(0, 200));
      });
    }
  },
  mounted() {
    setTimeout(() => {
      const el = document.querySelector("#svgg");
      //console.log(el)
      this.DOM = {};
      this.DOM.el = el;
      this.DOM.paths = Array.from(this.DOM.el.querySelectorAll("path"));
      this.animate();
    }, 2000);
  }
};
</script>

<style lang="scss">
#intro {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(#0a1d59, #4c499b);
  border-radius: 0% 0% 23% 23% / 7%;
  .row {
    position: relative;
    top: 4%;
    .arrow {
      width: 40px;
      height: 40px;
    }
    Illustration {
      max-width: 300px;
      width: 15%;
      min-width: 150px;
    }
    h1 {
      line-height: 1;
      font-size: 3.4rem;
    }
  }
  .covid {
    width: 90%;
    max-width: 900px;
    min-width: 150px;
    position: absolute;
    left: 5%;
    top: 70%;
  }
}

// Medium large devices (desktops, 992px and up)
@media (min-width: 768px) and (max-width: 991px) {
  #intro {
    border-radius: 0% 0% 30% 30% / 10%;
    .covid {
      width: 70%;
      max-width: 900px;
      min-width: 150px;
      position: absolute;
      left: 15%;
      top: 70%;
    }
  }
}

// Large devices (large desktops, 1400px and up)
@media (min-width: 992px) and (max-width: 1399px) {
  #intro {
    border-radius: 0% 0% 40% 40% / 16%;
    .covid {
      width: 60%;
      max-width: 900px;
      min-width: 150px;
      position: absolute;
      left: 20%;
      top: 65%;
    }
  }
}

// Extra large devices (large desktops, 1400px and up)
@media (min-width: 1400px) {
  #intro {
    border-radius: 0% 0% 45% 45% / 17%;
    .covid {
      width: 60%;
      max-width: 900px;
      min-width: 150px;
      position: absolute;
      left: 20%;
      top: 60%;
    }
  }
}
</style>
